import {
  CreditReportActionSubtypeEnum,
  CreditReportField,
  LoanActionRequestPayloadType,
  LoanEditorActionsEnum,
} from 'constants/loanActionEditor';

export const REDIRECT_DELAY_MS = 1000;

export const REGGORA_IFRAME_DRAWER_TITLE = 'Reggora Appraisal';
// Fallback when the OpenIframe result carries no EmptyMessage; normally the backend supplies the
// surface-specific text (loan file vs order) on the result itself.
export const REGGORA_NO_APPRAISAL_MESSAGE = 'No Reggora appraisal exists for this loan yet.';
// Fallback when an OpenUrlInNewTab result carries no url and no EmptyMessage; normally the backend
// supplies the message (the HomeVision open-order-page executor always does).
export const NO_ORDER_PAGE_MESSAGE = 'No order page is available for this loan yet.';
export const CREDIT_REPORT_DOCUMENT_RETRY_DELAY_MS = 2000;
export const CREDIT_REPORT_DOCUMENT_MAX_RETRIES = 3;

export const reportActions = [
  LoanEditorActionsEnum.ORDER_UPDATE_REPORT_MANUAL,
  LoanEditorActionsEnum.ORDER_UPDATE_REPORT_AUTO,
];

export const createReportType = `${CreditReportField.value}.${CreditReportActionSubtypeEnum.Create}`;
export const associateReportType = `${CreditReportField.value}.${CreditReportActionSubtypeEnum.Associate}`;
export const updateReportType = `${CreditReportField.value}.${CreditReportActionSubtypeEnum.Update}`;

export const actionReportTypes = [createReportType, associateReportType, updateReportType];

const CreditReportActionType = {
  RUN_CREDIT_REPORT: 'runCreditReport',
  RE_RUN_CREDIT_REPORT: 'reRunCreditReport',
  ASSOCIATE_CREDIT_REPORT: 'associateCreditReport',
};

export const StatusMessageReplacerType = {
  SUCCESS_FULL_NAMES: '_successFullNames_',
  ERROR_REASONS: '_errorReasons_',
  ERROR_FULL_NAMES: '_errorFullNames_',
};

export const creditReportStatusMessage = {
  [CreditReportActionType.RUN_CREDIT_REPORT]: {
    success: `The report was successfully received for borrower(s)/NBE('s) ${StatusMessageReplacerType.SUCCESS_FULL_NAMES}`,
    warning:
      `The report was successfully received for borrower(s)/NBE('s) ${StatusMessageReplacerType.SUCCESS_FULL_NAMES}, ` +
      `but failed for borrower(s)/NBE('s): ${StatusMessageReplacerType.ERROR_FULL_NAMES} due to:
    ${StatusMessageReplacerType.ERROR_REASONS}.
    Please verify borrower/NBE information and confirm that the borrower(s)/NBE('s) did not freeze their credit.`,
  },
  [CreditReportActionType.RE_RUN_CREDIT_REPORT]: {
    success: `Reissue of the credit report for borrower(s)/NBE('s) ${StatusMessageReplacerType.SUCCESS_FULL_NAMES} was successfully completed`,
    warning:
      `Reissue of the credit report for borrower(s)/NBE('s) ${StatusMessageReplacerType.SUCCESS_FULL_NAMES} was successfully completed, ` +
      `but failed for borrower(s)/NBE('s): ${StatusMessageReplacerType.ERROR_FULL_NAMES} due to:
    ${StatusMessageReplacerType.ERROR_REASONS}.
    Please verify borrower/NBE information and confirm that the borrower(s)/NBE('s) did not freeze their credit.`,
  },
  [CreditReportActionType.ASSOCIATE_CREDIT_REPORT]: {
    success: `The new report is associated with borrower/NBE ${StatusMessageReplacerType.SUCCESS_FULL_NAMES}`,
    warning: '',
  },
};

export const creditReportServiceUnavailableMessage =
  'There is no response from the credit provider. Please try again in a few minutes.';

export const getCreditReportActionTypeFromLoanActionType = actionType => {
  switch (actionType) {
    case LoanActionRequestPayloadType.CreditReportCreate:
      return CreditReportActionType.RUN_CREDIT_REPORT;
    case LoanActionRequestPayloadType.CreditReportUpdate:
      return CreditReportActionType.RE_RUN_CREDIT_REPORT;
    case LoanActionRequestPayloadType.CreditReportAssociate:
      return CreditReportActionType.ASSOCIATE_CREDIT_REPORT;
    default:
      return null;
  }
};
